import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

const fragments = {
	INPUT: '[data-fragment="TogglePassword.input"]',
	LINK: '[data-fragment="TogglePassword.link"]',
};

class TogglePassword extends WebComponent {
	constructor(props) {
		super(props);
		const {
		} = props;
		this.state = {
		};
	}

	didMount () {
		this.inputElement = this.element.querySelector(fragments.INPUT);
		this.on('click', fragments.LINK, this.handleClickOnLink);
	}

	handleClickOnLink = (e)=> {
		e.preventDefault();
		if(this.inputElement.type === 'password') {
			this.element.classList.add('active');
			this.inputElement.type = "text";
		} else {
			this.element.classList.remove('active');
			this.inputElement.type = "password";
		}
	}
}

export default TogglePassword;




// WEBPACK FOOTER //
// ./config/module-publish/resources/js/components/TogglePassword.js